import { Button, Grid, Row, Space } from "antd";

import ModelsAccordion from "./ModelsAccordion";
import React from "react";

const { useBreakpoint } = Grid;

const AboutCourse = ({ aboutCourse }) => {
  const breakpoint = useBreakpoint();

  const [dashboardData, setDashboardData] = React.useState(null);

  React.useEffect(() => {
    localStorage.getItem('dashboard') && setDashboardData(JSON.parse(localStorage.getItem('dashboard')));
  }, []);

  const course_conference_link = dashboardData?.courses_info.find(course => course.course_id === aboutCourse?.course_id)?.conference_link;

  const buttons = [
    {
      condition: !!dashboardData?.hpad,
      text: "HPAD",
      link: dashboardData?.hpad,
    },
    {
      condition: dashboardData?.pearson_platform_link?.length > 0,
      text: "Plataforma Pearson",
      link: dashboardData?.pearson_platform_link,
    },
    {
      condition: dashboardData?.connectivity_platform_link?.length > 0,
      text: "Plataforma Spark",
      link: dashboardData?.connectivity_platform_link,
    },
    {
      condition: dashboardData?.pedagogic_support_link?.length > 0,
      text: "Suporte Pedagógico",
      link: dashboardData?.pedagogic_support_link,
    },
    {
      condition: dashboardData?.financial_support_link?.length > 0,
      text: "Suporte Financeiro",
      link: dashboardData?.financial_support_link,
    },
    {
      condition: course_conference_link?.length > 0,
      text: "Ir para a aula",
      link: course_conference_link,
    },
  ];

  return (
    <>
      <section
        style={{
          display: "flex",
          justifyContent: "end",
          borderRadius: 3,
          flexWrap: 'wrap',
          gap: 10,
          marginTop: breakpoint.md ? 10 : 0,
        }}
      >
        <Space
          size={breakpoint.md ? 10 : 5}
          style={{
            display: "flex",
            justifyContent: "end",
            flexWrap: 'wrap',
          }}
        >
          {buttons.map((button, index) =>
            button.condition && (
              <Button
                key={index}
                type="primary"
                onClick={() => {
                  window.open(button.link, '_blank');
                }}
              >
                {button.text}
              </Button>
            )
          )}
        </Space>
      </section>
      <ModelsAccordion data={aboutCourse?.course_modules} courseHash={aboutCourse?.course_hash} />
    </>
  );
};

export default AboutCourse;
